import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { WARNING_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const WarningRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={WARNING_ROUNDED_GLYPH} />;
